<template>
    <!-- This component is a stop-gap until the design system version gets upgraded
    It simply adds the 'title' slot to ds-list-item -->
    <component
        :is="as"
        class="list-item"
        :class="[`border-${borderStyle}`, { clickable: isClickable }]"
        v-on="$listeners"
    >
        <div v-if="$slots.leadingSlot" class="leading-slot">
            <!-- @slot Icon or avatar to display before the list item text. -->
            <slot name="leadingSlot" />
        </div>

        <div class="list-item-info">
            <div class="item-text">
                <div v-if="title || $slots.title" class="title one-line">
                    <slot name="title">
                        {{ title }}
                    </slot>
                </div>

                <div
                    v-if="description || $slots.description"
                    class="description"
                    :class="[{ 'one-line': hasShortDescription }]"
                >
                    <slot name="description">
                        {{ description }}
                    </slot>
                </div>

                <div v-if="hasShortDescription" class="description one-line">
                    <slot name="shortDescription">
                        {{ shortDescription }}
                    </slot>
                </div>
            </div>

            <div v-if="$slots.trailingSlot" class="trailing-slot">
                <!-- @slot Checkbox or other to display after list item text. -->
                <slot name="trailingSlot" />
            </div>
        </div>
    </component>
</template>

<script>
import ListItem from '@infusionsoft/design-system/src/components/ListItem/ListItem';

export default {
    extends: ListItem,
};
</script>
